import {Desk, EntityType} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import {Desks_Read} from "../util/access/Permission";

export const useDeskStore = create<EntityStore<Desk[]>>()(
    officeArrayResource<Desk, EntityStore<Desk[]>>(EntityType.Desks, builder => {
        const rest = builder.crud('/desks', 'id');

        return {
            remoteValue: builder.all(Desks_Read, () => rest.getAll()),
        };
    })
);

startEntityStore(useDeskStore);
